const TOASTER_TYPE = {
    SUCCESS: 'success',
    ERROR: 'error',
    INFO: 'info',
    WARNING:'warning'
};

export default TOASTER_TYPE;
